<template>
  <div class="feedback-page">
    <div class="feedback-section">
      <div class="wrapper">
        <div class="feedback-wrapper">
          <div class="feedback-form-wrapper">
            <h2 class="title text-white">
              {{ $t("Leave Feedback") }}
            </h2>
            <form @submit.prevent="sendFeedback" class="feedback-form">
              <div class="input-container">
                <input
                  type="text"
                  id="name"
                  :placeholder="$t('Your Name')"
                  v-model="name"
                  required
                />
              </div>
              <div class="input-container">
                <input
                  type="email"
                  id="email"
                  :placeholder="$t('Your Email')"
                  v-model="email"
                  required
                />
              </div>
              <div class="input-container">
                <textarea
                  id="message"
                  :placeholder="$t('Your Message')"
                  v-model="message"
                  rows="5"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                class="button yellow small"
                :disabled="isLoading"
              >
                {{ isLoading ? $t("Sending...") : $t("Send Feedback") }}
              </button>
              <p
                v-if="feedbackMessage"
                class="message"
                :class="{ error: status === 'ERROR' }"
              >
                {{ feedbackMessage }}
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeedbackForm",
  data() {
    return {
      name: "",
      email: "",
      message: "",
      feedbackMessage: "",
      status: "",
      isLoading: false,
    };
  },
  methods: {
    sendFeedback() {
      this.clearError();
      if (this.isLoading) return;
      this.isLoading = true;

      this.$http
        .post(`${process.env.VUE_APP_API}feedback`, {
          name: this.name,
          email: this.email,
          message: this.message,
        })
        .then((response) => {
          if (response.data.status === "OK") {
            this.$toast.success(
              this.$t("Your feedback has been sent successfully!")
            );
            this.name = "";
            this.email = "";
            this.message = "";
          } else {
            this.showError(response.data.message);
          }
        })
        .catch((error) => {
          console.error(error);
          this.showError(
            error.response?.data?.message ||
              this.$t("An error occurred while sending your feedback.")
          );
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showError(errorMessage) {
      this.status = "ERROR";
      this.feedbackMessage = errorMessage;
      setTimeout(() => this.clearError(), 6000);
    },
    clearError() {
      this.status = "";
      this.feedbackMessage = "";
    },
  },
};
</script>

<style scoped lang="scss">
.feedback-page {
  .feedback-section {
    padding-top: 0;
    text-align: center;

    .wrapper {
      padding: 80px 0;
    }
  }

  .feedback-wrapper {
    max-width: 500px;
    width: 100%;
    margin: 0 auto;
    border-radius: 8px;
    overflow: hidden;
    margin: 0 auto;
    position: relative;
    z-index: 1;
    min-height: 100%;
    position: relative;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    padding: 46px 16px;
    width: 100%;
    background: #424648;
    border-radius: 24px;
    border: 1px solid #ffffff1a;
    background-image: url("@/assets/img/modal.webp");
    background-size: cover;
    background-position: center;
  }

  .feedback-form-wrapper {
    background: transparent;
    text-align: center;
    max-width: 372px;
    width: 100%;
    margin: 0 auto;

    .title {
      margin-bottom: 28px;
      padding: 0;
    }
  }

  .feedback-form {
    .input-container {
      width: 100%;
      text-align: left;

      .desc {
        margin-bottom: 8px;
        font-size: 14px;
        line-height: 19px;
        color: #aab0c5;
      }

      textarea {
        width: 100%;
        padding: 8px 16px;
        background: #2f3436;
        border: 1px solid #ffffff33;
        border-radius: 16px;
        color: #fff;
        box-shadow: 0px 2px 6px 0px #00000054 inset;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        outline: 0;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
      }

      textarea {
        min-height: 120px;
        resize: vertical;
      }
    }

    .button {
      margin-top: 8px;
    }

    .message {
      margin-top: 16px;
      font-size: 14px;
      line-height: 19px;
      color: #50af55;

      &.error {
        color: #f3453e;
      }
    }
  }
}
</style>
